import { SvgIcon, Typography } from '@mui/material';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import AttachmentIcon from '../../../../icons/svg/attachment.svg?react';

export const DropzoneContent: FC = () => {
  const { t } = useTranslation('template');

  return (
    <div
      style={{
        position: 'relative',
        width: '100%',
        height: '100%'
      }}
    >
      <div
        style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          textAlign: 'center'
        }}
      >
        <SvgIcon component={AttachmentIcon} sx={(theme) => ({ color: theme.palette.grey[900] })} />
        <Typography
          variant="body2"
          textAlign={'center'}
          overflow="hidden"
          textOverflow="ellipsis"
          sx={(theme) => ({
            color: theme.palette.grey[900],
            marginTop: '10px',
            whiteSpace: 'nowrap'
          })}
        >
          {t('SELECT_FILE_OR_DROP_IT')}
        </Typography>
      </div>
    </div>
  );
};
